import { Component, OnInit } from '@angular/core';
import { HttpclientService } from 'src/app/services/httpclient.service';

@Component({
  selector: 'app-clear-purchase-order',
  templateUrl: './cancel-purchase-order.component.html',
  styleUrls: ['./cancel-purchase-order.component.css']
})

export class CancelPoComponent implements OnInit {

  purchaseOrderNumber: string = 'Test004DONOTPROCESS';
  updateStatus: String;
  createModalPopup;
  puchaseOrderNumberBoxModal;
  data;
  isAxaltaCartKeyUpdated: boolean;
  updatedAxaltaCartKey;
  showMessage;
  constructor(private httpclientService: HttpclientService) { }
  
  ngOnInit() {
  }

  clearPurchaseOrder()
  {    
    this.data = [];    
    this.createModalPopup = false;
    this.httpclientService.updateClearPurchaseOrderItem(this.puchaseOrderNumberBoxModal).subscribe(
      
       data => {
         this.data = data;
         this.updatedAxaltaCartKey = this.puchaseOrderNumberBoxModal;
         console.log("Result of Axalta Cart Key Update " + this.data[0].axaltaCartKey);  

         if(this.data[0].axaltaCartKey == 'Y')
         {
           this.isAxaltaCartKeyUpdated = true;
         }
         else{
          this.isAxaltaCartKeyUpdated = false
         }
 
      }
    );
    
  }

  openPopupCreateBOL() {
    if (!this.puchaseOrderNumberBoxModal) {
      //this.loading = false;
      this.showMessage = 'Please Enter AxaltaCartKey.';
        }  else {
          this.showMessage = '';
          this.createModalPopup = true;
        }
    
  }


  keyPressNumbersDecimal(event) {
    var inp = String.fromCharCode(event.keyCode);
    console.log(inp);
    var len = inp.length;  
     
    if(len > 0)
    {
      this.showMessage = '';
    }
    
  }
  
  onSearchChange(searchValue: string): void {  
   
    
  }


















  pressingCancel() {
    this.createModalPopup = false;
  }
}
